/*global FWP*/
import $ from 'jquery';

const $document = $( document );

/**
 * Header setup.
 */
export function setupHeader() {
	const $button = $( '.js-menu-toggle' );
	const $menuDesktop = $( '#js-nav-service' );
	const $menuMobile = $( '#js-nav-global' );
	const $submenuButton = $( '.js-nav-global__submenu-button' );
	const $submenu = $( '.js-nav-global__subnav-list' );
	let mql = window.matchMedia( "screen and (min-width:" + window.app.env.breakpoints.min.xl + "px)" );

	const setup = function() {
		$button.attr( 'aria-pressed', 'false' );
		$menuDesktop.attr( 'aria-hidden', 'true' );

		/**
		 * Desktop
		 */
		if ( mql.matches ) {
			$button.attr( 'aria-controls', 'js-nav-service' );
			$menuMobile.attr( 'aria-hidden', 'false' );
			$submenu.attr( 'aria-hidden', 'false' );
			$submenuButton.attr( 'tabindex', '-1' );
		}
		/**
		 * Mobile
		 */
		else {
			$button.attr( 'aria-controls', 'js-nav-global' );
			$menuMobile.attr( 'aria-hidden', 'true' );
			$submenu.attr( 'aria-hidden', 'true' );
			$submenuButton.attr( 'tabindex', '0' );
		}
	}

	setup();
	mql.onchange = () => setup();
}

/**
 * Toggle nav 
 */
export function toggleNav() {
	const $button = $( '.js-menu-toggle' );
	let mql = window.matchMedia( "screen and (min-width:" + window.app.env.breakpoints.min.xl + "px)" );
	let timeout;

	const toggle = function() {
		let $panel = $( '#' + $button.attr( 'aria-controls' ) );

		if ( $button.attr( 'aria-pressed' ) === 'true' ) {
			$button.attr( 'aria-pressed', false );
			$panel.attr( 'aria-hidden', true );
		}
		else {
			$button.attr( 'aria-pressed', true );
			$panel.attr( 'aria-hidden', false );
		}
	};

	const open = function() {
		if ( mql.matches ) {
			let $panel = $( '#' + $button.attr( 'aria-controls' ) );

			$button.attr( 'aria-pressed', true );
			$panel.attr( 'aria-hidden', false );

			$panel.one( 'mouseleave.toggleMenu', closePanel );
		}
	};

	const close = function() {
		if ( mql.matches ) {
			let $panel = $( '#' + $button.attr( 'aria-controls' ) );

			timeout = window.setTimeout( function() {
				$button.attr( 'aria-pressed', false );
				$panel.attr( 'aria-hidden', true );
			}, 50 )

			$panel.one( 'mouseenter.toggleMenu', function() {
				window.clearTimeout( timeout );
			} );
		}
	};

	const closePanel = function( e ) {
		let $panel = $( e.currentTarget );

		$button.attr( 'aria-pressed', false );
		$panel.attr( 'aria-hidden', true );
	};

	$button.on( 'click.toggleMenu', toggle );
	$button.on( 'mouseenter.toggleMenu', open );
	$button.on( 'mouseleave.toggleMenu', close );
}

/**
 * Hide FacetWP reset button while no facets are selected.
 **/
export function facetWpHideReset() {
	const $reset = $( '.js-fwp-reset' );

	const isEmptyObject = function( obj ) {
		let empty = true;
		for ( let prop in obj ) {
			empty = ( obj[ prop ].length > 0 ) ? false : empty;
		}
		return empty;
	};

	const toggleReset = function() {

		if ( typeof FWP !== 'undefined' && isEmptyObject( FWP.facets ) ) {
			$reset.attr( 'aria-pressed', 'true' );
		} else {
			$reset.attr( 'aria-pressed', 'false' );

		}
	};

	// Hide reset button while no facets are selected
	toggleReset();
	$document.on( 'facetwp-loaded', toggleReset );
}


/**
 * Toggle panel
 */
export function togglePanel() {
	const $button = $( '.js-toggle' );

	const toggle = function( e ) {
		let $button = $( e.currentTarget );
		let $controlers = $( '[aria-controls="' + $button.attr( 'aria-controls' ) + '"]' );
		let $panel = $( '#' + $button.attr( 'aria-controls' ) );

		if ( $button.attr( 'aria-pressed' ) === 'true' ) {
			$controlers.attr( 'aria-pressed', false ).removeClass( 'is-active' );
			$panel.attr( 'aria-hidden', true );
		}
		else {
			$controlers.attr( 'aria-pressed', true ).addClass( 'is-active' );
			$panel.attr( 'aria-hidden', false );
		}
	};

	$button.on( 'click.toggle', toggle );
}

export default function hideOnLeave() {
	const $panel = $( '.js-hide-on-leave' );
	let mql = window.matchMedia( "screen and (min-width:" + window.app.env.breakpoints.min.xl + "px)" );

	const hide = function( e ) {
		if ( mql.matches ) {
			let $panel = $( e.currentTarget );
			let $controlers = $( '[aria-controls="' + $panel.attr( 'id' ) + '"]' );

			$controlers.attr( 'aria-pressed', false );
			$panel.attr( 'aria-hidden', true );
		}
	};

	const hideBlur = function( e ) {
		if ( mql.matches ) {
			const currentTarget = e.currentTarget;

			// Give browser time to focus the next element
			window.requestAnimationFrame( () => {
				// Check if the new focused element is a child of the original container
				if ( !currentTarget.contains( document.activeElement ) ) {
					hide( e );
				}
			} );
		}
	};

	$panel.on( 'mouseleave.toggle', hide );
	$panel.on( 'focusout', hideBlur );
}

export function mediaelement() {

	$( 'video[controls]' ).mediaelementplayer( {
		stretching: 'fill',
		hideVideoControlsOnLoad: false,
		hideVideoControlsOnPause: false,
	} );

}

/**
 * Tabs
 * @see https://github.com/jonathantneal/posthtml-aria-tabs/blob/master/client.js
 **/
export function tabs() {
	// Cache stores tab-panel pairs, last stores the currently active tab
	var cache = {}, last;

	// Loop through all tablists on the page
	Array.prototype.forEach.call( document.querySelectorAll( '[role="tablist"]' ), function( tablist ) {
		// Loop through all tabs in each tablist
		Array.prototype.forEach.call( tablist.querySelectorAll( '[href^="#"][role="tab"]' ), function( tab, index, tabs ) {
			// Store tab and its corresponding panel in cache using the tab's hash as key
			cache[ tab.hash ] = [ tab, document.getElementById( tab.getAttribute( 'aria-controls' ) ) ];

			// Set the initially selected tab and track it, disable tabindex for others
			if ( tab.getAttribute( 'aria-selected' ) === 'true' ) {
				last = cache[ '' ] = cache[ tab.hash ];
			} else {
				tab.setAttribute( 'tabindex', -1 );
			}

			// Handle keyboard navigation (arrow keys)
			tab.addEventListener( 'keydown', function( event ) {
				// Left arrow (37) goes to previous tab, right arrow (39) goes to next tab
				var next = event.keyCode === 37 ? tabs[ index - 1 ] : event.keyCode === 39 ? tabs[ index + 1 ] : null;

				if ( next ) {
					window.location.hash = next.hash;
					next.focus();
				}
			} );
		} );
	} );

	// Listen for hash changes to switch between tabs
	window.addEventListener( 'hashchange', onhashchange );

	onhashchange();

	// Function to handle tab switching when hash changes
	function onhashchange() {
		var tab = cache[ window.location.hash ];

		if ( tab ) {
			// Deactivate previously selected tab
			if ( last ) {
				last[ 0 ].removeAttribute( 'aria-selected' );
				last[ 0 ].setAttribute( 'tabindex', -1 );
				last[ 1 ].setAttribute( 'aria-hidden', 'true' );

				let video = last[ 1 ].querySelector( 'video' );
				if ( video ) {
					video.pause();
				}
			}

			// Activate the new tab
			tab[ 0 ].setAttribute( 'aria-selected', 'true' );
			tab[ 0 ].removeAttribute( 'tabindex' );
			tab[ 1 ].setAttribute( 'aria-hidden', 'false' );

			let video = tab[ 1 ].querySelector( 'video' );
			if ( video ) {
				video.play();
			}

			last = tab;
		}
	}
}